import React, { useRef } from "react";
import styled from "styled-components";

import { useJumpBar } from "@examspark/common-ui/dist/components/utils/JumpBar";

import {
  AlignmentViewSectionData,
  AlignmentViewSectionVisibility,
} from "./AlignmentViewData";
import AlignmentViewRow from "./AlignmentViewRow";

const SectionTitle = styled.tr`
  position: sticky;
  top: var(--section-title-offset);
  background-color: #fff;
  z-index: 1;

  td {
    border-inline: none !important;
    padding: 1rem;
    font-weight: 500;
    font-size: 1.3rem;
    color: #431f99 !important;
    -webkit-text-size-adjust: 100%;
  }
`;

const InvisibleRow = styled.tr`
  scroll-margin-top: calc(9rem - 2px);

  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

type Props = {
  section: AlignmentViewSectionData;
  visibility: AlignmentViewSectionVisibility;
  label: string;
};

const AlignmentViewSection = ({ section, visibility }: Props) => {
  const ref = useRef<HTMLTableRowElement>(null);
  useJumpBar({ label: section.title, ref, isSubsection: false });

  return (
    <>
      {/* 
        This tracks the original position in the viewport of the section title
        so that we have something to jumpbar to. TabIndex is so that using the 
        jump moves focus so that a user can scroll with arrow keys after
      */}
      <InvisibleRow ref={ref} tabIndex={-1} />
      {section.header && (
        <SectionTitle>
          <td colSpan={99}>{section.header}</td>
        </SectionTitle>
      )}
      {visibility.isVisible ? (
        section.rows?.map((row, i) => {
          return (
            <AlignmentViewRow
              key={row.id}
              data={row}
              visibility={visibility.rows[i]}
            />
          );
        })
      ) : (
        <tr>
          <td colSpan={99}>
            <i>No results matching grade selection or filter text</i>
          </td>
        </tr>
      )}
    </>
  );
};

export default AlignmentViewSection;
